/** Глобал, который инжектит Tauri-рантайм в WebView. */
type TauriWindow = Window & { __TAURI__?: unknown };

export const isTauri =
  typeof window !== "undefined" && !!(window as TauriWindow).__TAURI__;

export function checkIsTauri(): boolean {
  return typeof window !== "undefined" && !!(window as TauriWindow).__TAURI__;
}

export async function invokeTauri<T>(
  cmd: string,
  args?: Record<string, unknown>,
): Promise<T> {
  if (!isTauri) throw new Error("Not in Tauri environment");
  const { invoke } = await import("@tauri-apps/api/core");
  return invoke<T>(cmd, args);
}

export async function listenTauri<T>(
  event: string,
  handler: (payload: T) => void,
): Promise<(() => void) | undefined> {
  if (!isTauri) return undefined;
  const { listen } = await import("@tauri-apps/api/event");
  const unlisten = await listen<T>(event, (e) => handler(e.payload));
  return unlisten;
}

export async function getTauriVersion(): Promise<string | null> {
  if (!isTauri) return null;
  const { getVersion } = await import("@tauri-apps/api/app");
  return getVersion();
}
